import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Auth guard — allows access only when a valid session exists.
 * If the JWT is expired but a refresh token is available, the interceptor
 * will attempt a refresh on the first API call, so we allow navigation.
 * Only block when there is no session at all.
 */
export const authGuard: CanActivateFn = (route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    if (authService.hasSession()) {
        return true;
    }

    // No session — redirect to login with return URL
    router.navigate(['/auth/login'], {
        queryParams: { returnUrl: state.url }
    });
    return false;
};
